import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import moment from "moment";

import { usePatient } from "../../context/PatientContext";
import VitalTableCard from "../UI/VitalTableCard";
import ReuseableModel from "../Modals/ReuseableModel";
import { formatDate, formatTime } from "../../utils/chartUtils";
import { listWeightVital } from "../../HTTPS/VitalApis";
import WeightEditVitalForm from "../Forms/WeightEditVitalForm";

function WeightTable() {
  const [open, setOpen] = useState(false);
  const [entry, setEntry] = useState({});
  const { patient } = usePatient();

  const { data, isLoading } = useQuery({
    queryKey: ["weigthVitalList", patient?.id],
    queryFn: () => listWeightVital(patient?.providerUserId),
    enabled: !!patient?.id,
    refetchOnWindowFocus: false,
  });

  if (isLoading) {
    return (
      <div className="w-full p-3 bg-black/40 rounded-lg text-center text-white text-lg">
        {<p>Loading...</p>}
      </div>
    );
  }

  data?.sort((a, b) => {
    if (moment(a.date).isSame(b.date)) {
      return a.id < b.id ? 1 : -1; // because seconds are not there so we are comparing SQL id
    } else {
      return moment(a.date).isBefore(b.date) ? 1 : -1;
    }
  });

  return (
    <>
      <VitalTableCard
        valOne="lb"
        date="Date"
        time="Time"
        isButtonHeading="Edit"
      />
      {data?.map((i) => (
        <VitalTableCard
          valOne={i.weight}
          date={formatDate(i?.date)}
          time={formatTime(i?.date)}
          onClick={() => {
            setOpen(true);
            setEntry(i);
          }}
          createdBy={i?.createdBy}
        />
      ))}
      <ReuseableModel open={open} setOpen={setOpen}>
        <WeightEditVitalForm setOpen={setOpen} entry={entry} />
      </ReuseableModel>
    </>
  );
}

export default WeightTable;
